import { createApp } from 'vue';
import menu_main from "./MenuMain.vue";

const G_MENU_MAIN_PAGE = createApp({
    name: "G_MENU_MAIN_PAGE",
    id: "G_MENU_MAIN_PAGE",
    components: {
        menu_main
    }
});
export default G_MENU_MAIN_PAGE;


